var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-badge',{attrs:{"status":_vm.currentStatus.messageType,"text":""}}),_vm._v(" "),_c('span',{class:[`trawl-status-${_vm.currentStatus.messageType}`]},[_vm._v(_vm._s(_vm.currentStatus.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }